import Link from "next/link";

import { Button, Card, Language } from "@chef/components";
import { DiscountLost } from "@chef/icons/symbol";
import { Modal } from "@chef/smart-components";

import { intl } from "./CancelSubscriptionModal.Intl";

interface CancelSubscriptionModalProps {
  show: boolean;
  closeModal: () => void;
  onConfirmCancellationClicked: () => void;
  discountsToBeLost: string[];
  language: Language;
  linkToPauseSubscriptionForPeriodPage: string;
}

export const CancelSubscriptionModal = ({
  show,
  closeModal,
  onConfirmCancellationClicked,
  discountsToBeLost,
  linkToPauseSubscriptionForPeriodPage,
}: CancelSubscriptionModalProps) => {
  const {
    ACTIVE_DISCOUNT_CODES_WILL_BE_LOST,
    CODES,
    END_SUBSCRIPTION_ANYWAY,
    CANCEL,
    TAKE_A_LONGER_BREAK,
    CODE,
  } = intl;
  return (
    <Modal open={show} onClose={closeModal} size="md">
      <Card noPadding className="flex flex-col items-center p-8 pt-20 mt-20">
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-grey-3">
          <div className="flex w-20 h-20 p-4">
            <DiscountLost className="w-auto h-auto" />
          </div>
        </div>
        <h2 className="mt-8 text-xl text-center md:text-2xl">
          {ACTIVE_DISCOUNT_CODES_WILL_BE_LOST}
        </h2>
        <p className="mt-2">{discountsToBeLost.length > 1 ? CODES : CODE}</p>
        <ul className="flex flex-col items-center">
          {discountsToBeLost.map((discount) => (
            <li key={discount}>
              <strong>{discount}</strong>
            </li>
          ))}
        </ul>
        <div className="flex flex-col gap-2">
          <Button
            data-testid="confirmCancelSubscriptionButton"
            className="mt-8"
            primary
            onClick={onConfirmCancellationClicked}
          >
            {END_SUBSCRIPTION_ANYWAY}
          </Button>
          <Link href={linkToPauseSubscriptionForPeriodPage} passHref>
            <Button data-testid="cancelModalButton" outlined full>
              {TAKE_A_LONGER_BREAK}
            </Button>
          </Link>
        </div>

        <button className="mt-8 underline" onClick={closeModal}>
          {CANCEL}
        </button>
      </Card>
    </Modal>
  );
};
